import { CxsBasket, CxsBasketLineType, errorMessages } from '../model';
import { markProductUpdate, updateEntry } from '../utils';
import { BasketLine } from '@models/api-orders.models';

export const removeGiftWrappingOptions = (
    basket: CxsBasket,
    productId: string,
    type: CxsBasketLineType,
    id?: string
): CxsBasket => {
    const existingLineIndex = basket.lines.findIndex(currentLine => currentLine.variantNo === productId);
    const line = basket.lines[existingLineIndex];
    if (!line) {
        throw Error(errorMessages.productNotFound);
    }

    const giftOptions: Partial<Pick<BasketLine, 'giftWrappings' | 'giftWrappingsCard' | 'giftWrappingsCardText'>> = {};
    if (type === 'GiftWrapping') {
        if (id) {
            const removeIndex = line.giftWrappings.findIndex(wrapping => wrapping === id);
            if (removeIndex) {
                line.giftWrappings?.splice(removeIndex, 1);
                giftOptions.giftWrappings = line.giftWrappings;
            }
        } else {
            giftOptions.giftWrappings = [];
        }
    }

    // if we remove the card we need to remove also the card text
    if (type === 'GiftWrappingCard') {
        giftOptions.giftWrappingsCard = '';
        giftOptions.giftWrappingsCardText = '';
    }

    const lines = updateEntry(basket.lines, { ...giftOptions }, existingLineIndex);

    return {
        ...basket,
        lines,
        ...markProductUpdate(basket, productId)
    };
};
